// ---- room-meta.js ----
const ROOM_ICON_BASE = "/assets/front/images/report-icons/";
const ROOM_ICON_DEFAULT = ROOM_ICON_BASE + "default.svg";

// Keyed by taxonomy "key" (Living, Bedroom, …)
const ROOM_TYPE_META = {
  Living: {
    label: "Living / Lounge / Family",
    icon: ROOM_ICON_BASE + "living.svg",
  },
  Dining: { label: "Dining Area", icon: ROOM_ICON_BASE + "dining.png" },
  Kitchen: { label: "Kitchen", icon: ROOM_ICON_BASE + "kitchen.svg" },
  Pantry: {
    label: "Pantry / Butler’s Pantry",
    icon: ROOM_ICON_BASE + "pantry.svg",
  },
  Bedroom: { label: "Bedroom", icon: ROOM_ICON_BASE + "bedroom.png" },
  Study: { label: "Study / Office", icon: ROOM_ICON_BASE + "study.svg" },
  Bathroom: { label: "Bathroom", icon: ROOM_ICON_BASE + "bathroom.svg" },
  Ensuite: { label: "Ensuite", icon: ROOM_ICON_BASE + "ensuite.svg" },
  Powder: { label: "Powder Room / W.C.", icon: ROOM_ICON_BASE + "powder.svg" },
  Laundry: { label: "Laundry", icon: ROOM_ICON_BASE + "laundry.svg" },
  WIR: { label: "Walk-in Robe", icon: ROOM_ICON_BASE + "wardrobe.svg" },
  Robe: { label: "Wardrobe", icon: ROOM_ICON_BASE + "robe.svg" },
  Linen: { label: "Linen Store", icon: ROOM_ICON_BASE + "linen.svg" },
  Entry: { label: "Entry / Foyer", icon: ROOM_ICON_BASE + "entry.svg" },
  Hall: { label: "Hall / Corridor", icon: ROOM_ICON_BASE + "hall.svg" },
  Stairs: { label: "Stairs", icon: ROOM_ICON_BASE + "stairs.svg" },
  Lift: { label: "Lift / Elevator", icon: ROOM_ICON_BASE + "lift.svg" },
  Balcony: { label: "Balcony", icon: ROOM_ICON_BASE + "balcony.svg" },
  Terrace: { label: "Terrace", icon: ROOM_ICON_BASE + "terrace.svg" },
  Deck: { label: "Deck", icon: ROOM_ICON_BASE + "deck.svg" },
  Alfresco: {
    label: "Alfresco / Patio",
    icon: ROOM_ICON_BASE + "alfresco.svg",
  },
  Verandah: { label: "Verandah", icon: ROOM_ICON_BASE + "verandah.svg" },
  Porch: { label: "Porch", icon: ROOM_ICON_BASE + "porch.svg" },
  Courtyard: { label: "Courtyard", icon: ROOM_ICON_BASE + "courtyard.svg" },
  Yard: { label: "Yard / Garden", icon: ROOM_ICON_BASE + "yard.svg" },
  SwimmingPool: {
    label: "Swimming Pool",
    icon: ROOM_ICON_BASE + "swimming-pool.svg",
  },
  Spa: { label: "Spa / Hot Tub", icon: ROOM_ICON_BASE + "spa.svg" },
  Garage: { label: "Garage", icon: ROOM_ICON_BASE + "garage.svg" },
  Carport: { label: "Carport", icon: ROOM_ICON_BASE + "carport.svg" },
  Driveway: { label: "Driveway", icon: ROOM_ICON_BASE + "driveway.svg" },
  Shed: { label: "Shed / Store", icon: ROOM_ICON_BASE + "shed.svg" },
  BinStore: {
    label: "Bin Store / Refuse Room",
    icon: ROOM_ICON_BASE + "bin-store.svg",
  },
  CommonCorridor: {
    label: "Common Corridor / Lobby",
    icon: ROOM_ICON_BASE + "common-corridor.svg",
  },
  PlantRoom: {
    label: "Plant / Services Room",
    icon: ROOM_ICON_BASE + "plant-room.svg",
  },
};

// Safe getter (always returns an icon + label)
function getRoomMeta(typeKey) {
  const meta = ROOM_TYPE_META[typeKey];
  if (meta) return meta;
  return { label: typeKey || "Unknown", icon: ROOM_ICON_DEFAULT };
}

// Optional: expose globally for PlanBinder.init({ getRoomMeta })
window.ROOM_META = {
  ROOM_ICON_BASE,
  ROOM_ICON_DEFAULT,
  ROOM_TYPE_META,
  getRoomMeta,
};
